import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import IssueTypeTag from '../../common/issueTypeTag/IssueTypeTag';
import { ISSUE_TABLE_COPY, issueSummary } from '../issueTracker.constants';
import { DATE_TIME_SECONDS_FORMAT, formatDateTime } from '../../../utils/datetime';
import styles from '../styles/issue-kanban-board.module.scss';

/**
 * One issue as a board card.
 *
 * All that is left of the old `IssueKanbanColumn` after the board itself moved
 * to design-elements: the column, its paging and its empty state are generic,
 * and this is the Jira-shaped part. `KanbanBoard` supplies the card's chrome
 * (surface, selected ring, click target), so nothing here is a button.
 *
 * @param {Object} props
 * @param {{key: string, issueType?: string, summary?: string, assignee?: string, lastUpdatedAt?: string}} props.issue
 */
function IssueKanbanCard({ issue }) {
    return (
        <>
            <div className={styles.cardTop}>
                <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.cardKey}>
                    {issue.key}
                </Text>
                <IssueTypeTag type={issue.issueType} />
            </div>

            <Text as={TextAs.P} size={TextSizes.EXTRA_SMALL} className={styles.cardSummary}>
                {issueSummary(issue.summary)}
            </Text>

            <div className={styles.cardMeta}>
                <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.cardAssignee}>
                    {issue.assignee || ISSUE_TABLE_COPY.UNASSIGNED}
                </Text>
                {/* No status pill on a card: the column IS the status, and
                    repeating it would be noise. */}
                <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.cardDate}>
                    {formatDateTime(issue.lastUpdatedAt, DATE_TIME_SECONDS_FORMAT) || '—'}
                </Text>
            </div>
        </>
    );
}

export default IssueKanbanCard;
